import axios from "axios";
import { apiUrl } from '../utils/constants';

axios.defaults.withCredentials = true
// const API_URL = "http://localhost:8081/api/user";
const API_URL = `${apiUrl}/user`;

const updateUser = (data) => {
  console.log(data)
  return axios.post(API_URL + "/update", data)
  .then((response) => {
    console.log(response.data)
    return response.data;
  });
};


const setPersonalDetails = (data) => {
  console.log(data)
  return axios.post(API_URL + "/setPersonalDetails", data)
  .then((response) => {
    console.log(response.data)
    return response.data;
  });
};

const setLocation = (data) => {
  console.log(data)
  return axios.post(API_URL + "/setLocation", data)
  .then((response) => {
    console.log(response.data)
    return response.data;
  });
};

const addFileRef = (data, type) => {

  return axios.post(API_URL + `/addFileRef/${type}`, data, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
  .then((response) => {
    console.log(response.data)
    return response.data;
  });
};


const applyLoan = (data) => {
  console.log(data)
  return axios.post(API_URL + "/applyLoan", data)
  .then((response) => {
    console.log(response.data)
    return response.data;
  });
};



const uploadUserImage = (data) => {
  console.log(data)
  return axios.post(API_URL + "/uploadImage", data, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
  .then((response) => {
    console.log(response.data)
    return response.data;
  });
};

const uploadImage = (data) => {
  console.log(data)
  return axios.post(API_URL + "/upload/image", data, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
  .then((response) => {
    console.log(response.data)
    return response.data;
  });
};

const cashRequest = (type, data) => {
  console.log(data)
  return axios.post(API_URL + `/cashRequest/${type}`, data)
  .then((response) => {
    console.log(response.data)
    return response.data;
  });
};




export default {
 updateUser,
 uploadUserImage,
 uploadImage,
 setPersonalDetails,
  setLocation,
  addFileRef,
  applyLoan,
  cashRequest
};